import { Frame } from '@shopify/polaris';
import { TopBar } from './TopBar';
import { EditorShell } from './EditorShell';

export function EditorPage() {
  // Publish + status moved into the custom TopBar (Shopify parity), so the
  // page is just the top bar + the 3-pane shell.
  return (
    <Frame topBar={<TopBar />}>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <EditorShell />
      </div>
    </Frame>
  );
}
